import Vue from 'vue'
const $t = Vue.prototype.$t
/**
 *  @description nodeType 等于4 审批人校验规则
 *  staffs（审批人）类型Array 校验其length是否大于 0
 */
export const approvalRules = {
  // 审批人为空校验
  specify_resign: [
    {
      validator: (_, value, callback) => {
        const isArray = Array.isArray(value)
        if (isArray && value.length) {
          return callback()
        }
        callback(new Error($t('work_rule_45')))
      },
      trigger: ['blur', 'change']
    }
  ],
  // 审批人为空校验
  directorLevelPerson: [
    {
      validator: (_, value, callback) => {
        const isArray = Array.isArray(value)
        if (isArray && value.length) {
          return callback()
        }
        callback(new Error($t('work_rule_45')))
      },
      trigger: ['blur', 'change']
    }
  ],
  val: [
    {
      validator: (_, value, callback) => {
        const isArray = Array.isArray(value)
        if (isArray && value.length) {
          return callback()
        }
        if (!isArray && value) return callback()
        callback(new Error($t('work_rule_80')))
      }
    }
  ],
  settype: [{ required: true, message: $t('221') }]
}

// 分支条件校验规则
export const condiyionRules = {
  condition: [{ required: true, message: $t('221') }],
  operator: [{ required: true, message: $t('221') }],
  value: [
    {
      validator: (rule, value, callback) => {
        if (value.value || value) {
          callback()
        } else return callback(new Error($t('221')))
      }
    }
  ]
}

// 基础信息校验
export const baseRules = vm => ({
  name: [{ required: true, message: $t('f181bf5a') }],
  audit_type: [{ required: true, message: $t('work_rule_35') }],
  group_id: [{ required: true, message: $t('181bf5ae') }],
  allow_cancel_days: [
    {
      validator: (_, value, callback) => {
        if (vm.base.allow_type !== 3 || value) {
          callback()
        } else return callback(new Error($t('work_rule_54')))
      }
    }
  ],
  visible: [
    {
      validator: (_, value, callback) => {
        const arr = [...value.staff, ...value.department]
        if (value.toAll === 1 && !arr.length) return callback(new Error($t($t('i18n.1647917583450'))))
        callback()
      }
    }
  ],
  is_allow_cancel: [{ required: true, message: $t('work_rule_38') }]
})

/**
 * @description 条件组校验函数
 * @override 适用于有条件逻辑的节点 如节点分支 发起人type为2时
 * @param { Array } branchGroups
 */
const verificationBranch = branchGroups => {
  const status = branchGroups.every(item => {
    return Boolean(item.length && item[0].operator.name)
  })
  return status
}

/**
 * 审批节点或抄送节点校验
 * @param { Object } item
 * @returns { Boolean }
 */
const approvalVerification = item => {
  const type = item.type
  const Obj = item.form[type === 1 ? 'auditor' : 'cc']
  // 必须存在一个审批人 且不为空
  const state = Boolean(Obj.length && Obj[0].val)
  item.warning = {
    ...item.warning,
    status: !state
  }
  return state
}
// 分支节点校验  规则同上
const branchVerification = item => {
  if (item.isDefault) {
    item.warning = {
      msg: $t('work_rule_55'),
      status: false
    }
    return true
  }
  const state = verificationBranch(item.form)
  item.warning = {
    msg: $t('work_rule_55'),
    status: !state
  }
  return state
}

const verificationMap = new Map([
  // 审批人
  [1, approvalVerification],
  // 审批人
  [2, approvalVerification],
  // 条件
  [3, branchVerification]
])

/**
 *  @description 节点校验
 *  @param { Object } sourceData
 *  @returns { Boolean }
 */
export const verification = sourceData => {
  // console.log(sourceData)
  const status = !sourceData.childNode
    ? !(sourceData.conditionList && sourceData.conditionList.length)
    : !sourceData.childNode
  if (status) return
  const arr = [sourceData]
  // 校验结果
  let resultState = true
  // 深度遍历每个节点校验
  while (arr.length) {
    const current = arr.pop() // 移除数组的最后一个元素，并返回该元素。
    const childNode = current.childNode
    const conditionList = current.conditionList
    if (childNode) arr.unshift(childNode)
    if (conditionList) conditionList.forEach(el => arr.unshift(el))
    const verificationMethods = verificationMap.get(current.type)
    // 99为结束节点 默认没有配置函数
    if (verificationMethods && !verificationMethods(current)) resultState = false
  }
  return resultState
}
